angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/layout.html',
    '<div class="container-fluid" >\n' +
    '  <div class="header">\n' +
    '    <div class="left">\n' +
    '      <span>App Title</span>\n' +
    '    </div>\n' +
    '    <div class="right user-pop">\n' +
    '      User Info\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <ui-view />\n' +
    '</div>\n' +
    '');
}]);
